import { NgModule } from '@angular/core';
import { PhBhpAdduserComponent } from './ph-bhp-adduser/ph-bhp-adduser.component';
import { PhBhpManageuserComponent } from './ph-bhp-manageuser/ph-bhp-manageuser.component';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhBhpViewuserComponent } from './ph-bhp-viewuser/ph-bhp-viewuser.component';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';
// common libraries

@NgModule({
  declarations: [
    PhBhpAdduserComponent,
    PhBhpManageuserComponent,
    PhBhpViewuserComponent,
  ],
  imports: [
    PHBHPLayoutPackageModule,
    PHBHPLocalizePackageModule,
    FormsModule,
    ReactiveFormsModule,
    PhBhpUiModule,
    MatInputModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    MatListModule,
    ClientLibModule,
    PhBhpFeatureComponentsModule
  ],
  exports: [PhBhpManageuserComponent],
})
export class PHBHPFeaturePackageUserManagementModule {}
